import React, { useEffect, useRef, useState } from "react";
import { IoMdLock } from "react-icons/io";
import { MdKeyboardArrowDown } from "react-icons/md";
import { Link } from "react-router-dom";
import SubmenuItem from "./SubmenuItem";

const NavItem = ({ menuItem, setShowMenu }) => {
  const [showsubmenus, setShowsubmenus] = useState(false);
  const menuRef = useRef();

  const toggleSubmenu = () => {
    setShowsubmenus(!showsubmenus);
  };

  useEffect(() => {
    let handler = (e) => {
      if (menuRef !== null) {
        if (!menuRef.current.contains(e.target)) {
          setShowsubmenus(false);
        }
      }
    };
    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });
  return (
    <li
      ref={menuRef}
      className="z-50 lg:flex relative items-center gap-3 py-[10px] px-[20px] cursor-pointer hover:bg-[#dddddd38] text-[#333]"
      
    >
      {menuItem.submenus ? (
        <div className="flex items-center gap-1" onClick={() => setShowsubmenus(!showsubmenus)}>
          {menuItem.icon}
          <span>{menuItem.label}</span>
          {menuItem.submenus && <MdKeyboardArrowDown />}
        </div>
      ) : (
        <Link to={menuItem.path} className="flex items-center gap-3" onClick={()=>setShowMenu(false)}>
          {menuItem.icon}
          <span>{menuItem.label}</span>
        </Link>
      )}
      {menuItem.submenus && showsubmenus && (
        <ul className="lg:absolute top-[40px] right-32 left-0 bg-white py-[7px] min-w-[180px] border border-[#ddd] text-left">
          <li className="hidden lg:block my-[7px] h-[1px] bg-[#e5e5e5]"></li>
          {menuItem?.submenus?.map((submenu, index) => (
            <SubmenuItem key={index} submenu={submenu} setShowsubmenus={setShowsubmenus} setShowMenu={setShowMenu} />
          ))}
        </ul>
      )}
    </li>
  );
};

export default NavItem;
